export default __webpack_public_path__ + "static/media/deletDisable.65ae4075.svg";